"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWebPlayerUrl = void 0;
const utils_1 = require("./utils");
const getWebPlayerUrl = (bindingCode, apiUrl) => __awaiter(void 0, void 0, void 0, function* () {
    const headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
    };
    const prevUpdateChannel = (0, utils_1.getAppUpdateChannel)(bindingCode);
    const prevVersion = (0, utils_1.getAppVersion)(bindingCode);
    const graphql = JSON.stringify({
        query: "mutation DeviceUpdateWebPlayer3VersionMutation($bindingCode: String!, $currentVersion: String, $updateChannel: String) {\n    deviceUpdateWebPlayer3Version\n(bindingCode: $bindingCode, currentVersion: $currentVersion, updateChannel: $updateChannel) {\n      requiredVersionLink\n      updateChannel\n      requiredVersion\n    }\n}",
        variables: Object.assign(Object.assign({ bindingCode }, (prevUpdateChannel && { updateChannel: prevUpdateChannel })), (prevVersion && { currentVersion: prevVersion })),
    });
    const requestOptions = {
        method: "POST",
        headers,
        body: graphql,
    };
    try {
        return fetch(apiUrl, requestOptions).then((request) => request
            .json()
            .then((result) => result.data.deviceUpdateWebPlayer3Version)
            .then(({ requiredVersion, updateChannel, requiredVersionLink }) => {
            if (requiredVersionLink) {
                localStorage.setItem((0, utils_1.getUrlKey)(bindingCode), requiredVersionLink);
            }
            if (requiredVersion) {
                localStorage.setItem((0, utils_1.getVersionKey)(bindingCode), requiredVersion);
            }
            if (updateChannel) {
                localStorage.setItem((0, utils_1.getChannelKey)(bindingCode), updateChannel);
            }
            return requiredVersionLink;
        })
            .catch((error) => {
            console.error(error);
            return "";
        }));
    }
    catch (err) {
        console.error(err);
        return "";
    }
});
exports.getWebPlayerUrl = getWebPlayerUrl;
//# sourceMappingURL=api.js.map